import type { DecisionEngineDestinationUI } from "./definition";

export const attentiveUI: DecisionEngineDestinationUI = {
  campaignSetup: "event-triggered",
  resourceName: "journey",
  channelDescription: "Attentive",
  getReferenceString: (s) => `{{ triggerEvent.custom.${s} }}`,
  isInactive: () => true,
  isPreviewSupported: false,
  getResourceType: () => null,
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
  showAssociatedTemplate: false,
};
